// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7584110f] .body-textarea textarea{height:360px}", "",{"version":3,"sources":["webpack://./src/client/features/twitter_instantwin_message/serial_code_used_import/serial_code_used_import.vue"],"names":[],"mappings":"AAEE,0CACE,YAAA","sourcesContent":["\n:deep(.body-textarea) {\n  textarea {\n    height: 360px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
